const documentTitle = 'Redflag AI | The Industry Standard For Content And Brand Protection';

export { documentTitle as default };
